import { challengeDayPhase, type ChallengeDayPhase } from './challenge'
import { tripDateKey } from './tripTime'

export const PREVIEW_CHALLENGE_DAY = '2026-09-06'
export const PREVIEW_CHALLENGE_END = '2026-09-07'

export function isDaySixPreview(now = new Date()): boolean {
  return tripDateKey(now) < PREVIEW_CHALLENGE_DAY
}

export function displayedChallengeProductDay(now = new Date()): string {
  return tripDateKey(now) < PREVIEW_CHALLENGE_END ? PREVIEW_CHALLENGE_DAY : tripDateKey(now)
}

export function displayedChallengePhase(productDay: string, now = new Date()): ChallengeDayPhase {
  if (productDay === PREVIEW_CHALLENGE_DAY && isDaySixPreview(now)) return 'locked'
  return challengeDayPhase(productDay, now)
}
